
import { Component, Vue, Prop, Mixins, Watch } from "vue-property-decorator";
import { Line, mixins } from "vue-chartjs";

@Component
export default class LineChart extends Mixins(Line, mixins.reactiveProp) {
  @Prop()
  private options;

  @Watch("chartData.datasets.0.data", { immediate: false, deep: false })
  onPersonChanged1(val: any, oldVal: any) {
    this.$data._chart.update();
    this.$emit("generateLegend", this.$data._chart.generateLegend());
  }

  private mounted() {
    this.options.scales.xAxes[0].offset = false;
    this.renderChart(this.chartData, this.options);
    this.$emit("generateLegend", this.$data._chart.generateLegend());
  }
}
